import React, { FC } from 'react';
import { Notes } from '@flicent/fieldpulse-react-component-library-frontend';

import JobNotesProps from './JobNotes.props';


const JobNotes: FC<JobNotesProps> = ({ job }) => {
  return (
    <>
      { job.is_notes_visible && job.notes && <Notes label="Notes" text={ job.notes }/> }
      { job.is_field_notes_visible && job.field_notes && <Notes label="Field Notes" text={ job.field_notes }/> }
    </>
  );
};


export default JobNotes;